'use client';

import { useMediaQuery } from '@react-hookz/web';
import dynamic from 'next/dynamic';

import { routes } from '~constants/routes';
import { NSFWModeSwitch } from '~features/nsfw';
import { useSession } from '~hooks/useSession';
import { usePathname } from '~i18n/navigation';

import TextIcon from '../../../public/assets/text-icon.svg';
import { Neurons } from './AuthContent/Neurons';
import { BackLink } from './BackLink';
import { GeneratorHeading } from './GeneratorHeading';
import {
	Container,
	ContainerInner,
	Nav,
	Separator,
	SideContainer,
	StyledLink,
} from './Header.styles';
import { HeaderLinks } from './HeaderLinks';
import { Premium } from './Premium';

const HeaderAuthContent = dynamic(
	() => import('./AuthContent').then((mod) => mod.HeaderAuthContent),
	{ ssr: false }
);
const HeaderNonAuthContent = dynamic(
	() => import('./NonAuthContent').then((mod) => mod.HeaderNonAuthContent),
	{ ssr: false }
);

export const Header = () => {
	const pathname = usePathname();
	const { isDemoUser, isSafeMode } = useSession();
	const isMobile = useMediaQuery('screen and (max-width: 768px)');
	const isGeneratorHeader =
		isMobile &&
		[routes.generate.character, routes.generate.images].includes(pathname);

	const renderPremiumCta = !isDemoUser;
	const premiumCtaIsVisible = renderPremiumCta && !isSafeMode;

	return (
		<Container>
			<ContainerInner>
				{isGeneratorHeader ? (
					<>
						<SideContainer>
							<BackLink path={routes.generate.home} />
							{pathname === routes.generate.character && (
								<GeneratorHeading text="New AI character" />
							)}
							{pathname === routes.generate.images && (
								<GeneratorHeading text="Image Creation" />
							)}
						</SideContainer>

						<SideContainer nogap>
							<Neurons />
						</SideContainer>
					</>
				) : (
					<>
						<SideContainer>
							<StyledLink href={routes.index}>
								<TextIcon width={104} height={64} />
							</StyledLink>
							<Nav>
								<Separator />
								<HeaderLinks />
								{renderPremiumCta && (
									<Separator visible={premiumCtaIsVisible} />
								)}
							</Nav>
							{renderPremiumCta && <Premium visible={premiumCtaIsVisible} />}
						</SideContainer>
						<NSFWModeSwitch />
						{!isDemoUser ? <HeaderAuthContent /> : <HeaderNonAuthContent />}
					</>
				)}
			</ContainerInner>
		</Container>
	);
};

export const HeaderMini = () => (
	<Container>
		<ContainerInner>
			<SideContainer>
				<StyledLink href={routes.index}>
					<TextIcon width={82} height={40} />
				</StyledLink>
				<Nav>
					<Separator />
					<HeaderLinks />
				</Nav>
			</SideContainer>
		</ContainerInner>
	</Container>
);
